import * as ActionTypes from '../actions/cameraAction';

const initialState = {
  startDate: null,
  endDate: null,
  timeInterval: null,
};

const cameraReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_CAMERA_SEVERAL_VALUES: {
      return {
        ...state,
        ...action.payload,
      };
    }
    
    case ActionTypes.RESET_CAMERA_STORE: {
      return {
        ...state,
        ...initialState,
      };
    }
    
    default: {
      return state;
    }
  }
};

export default cameraReducer;
